import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

const API_URL =
  "https://etoile-bricolage-api.imanehibouzid2001.workers.dev";

function AdminLogin() {
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (!password.trim()) {
      setError("Veuillez saisir le mot de passe.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${API_URL}/api/admin/login`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        credentials: "include",

        body: JSON.stringify({
          password: password,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        setError(data.error || "Mot de passe incorrect.");
        return;
      }

      // Connexion réussie
      navigate("/admin/products");
    } catch (error) {
      console.error("Erreur connexion admin :", error);

      setError(
        "Impossible de contacter le serveur. Veuillez réessayer."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="admin-login-page">
      <div className="admin-login-card">

        <div className="admin-login-brand">
          ÉTOILE BRICOLAGE
        </div>

        <h1>Administration</h1>

        <p className="admin-login-description">
          Connectez-vous pour gérer les produits du catalogue.
        </p>

        {error && (
          <div className="admin-login-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>

          <div className="admin-login-field">
            <label htmlFor="admin-password">
              Mot de passe
            </label>

            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Votre mot de passe"
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="admin-login-button"
            disabled={loading}
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>

        </form>

        <button
          type="button"
          className="admin-login-back"
          onClick={() => navigate("/")}
        >
          ← Retour au site
        </button>

      </div>
    </main>
  );
}

export default AdminLogin;